import React from 'react'
import { withFirebase } from '../../components/Fb'

// reactstrap components
import {
  Row,
  Col
} from 'reactstrap'
import ResourceCategories from '../../components/Config/ResourceCategories'

// core components

class ConfigResourceCategoriesContainer extends React.Component {
  render () {
    return (
      <>
        <div className='content'>
          <Row>
            <Col md='12'>
              <ResourceCategories { ...this.props } />
            </Col>
          </Row>
        </div>
      </>
    )
  }
}

export default withFirebase(ConfigResourceCategoriesContainer)
